import { doPostRequestV1, doPostRequestV2 } from "./ApiService";
import { baseHeaders } from "./Headers";

export async function login(payload: any): Promise<any> {
  const url = `/auth?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
  };
  const response = await doPostRequestV1<any>(url, payload, headers);
  return response;
}

export async function loginV2(payload: any): Promise<any> {
  const url = `/auth?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-recaptcha": localStorage.getItem("captchaLogin")!,
  };
  const response = await doPostRequestV2<any>(url, payload, headers);
  return response;
}
